// Copyright 2015, Mike Bostock
// BSD 3-Clause License — https://github.com/d3/d3-sankey/blob/main/LICENSE
// Vendored from d3-sankey@0.12.3 — https://github.com/d3/d3-sankey

import type { SankeyExtraProperties, SankeyLink, SankeyNode } from './types.js';

interface ResolvedLink<
  N extends SankeyExtraProperties,
  L extends SankeyExtraProperties,
> {
  source: SankeyNode<N, L>;
  target: SankeyNode<N, L>;
  y0: number;
  y1: number;
}

export function sankeyLinkHorizontal<
  N extends SankeyExtraProperties,
  L extends SankeyExtraProperties,
>(): (link: SankeyLink<N, L>) => string | null {
  return function (link: SankeyLink<N, L>): string | null {
    const resolved = link as unknown as ResolvedLink<N, L>;
    const sx = resolved.source.x1 ?? 0;
    const sy = resolved.y0;
    const tx = resolved.target.x0 ?? 0;
    const ty = resolved.y1;
    const mx = (sx + tx) / 2;
    return `M${sx},${sy}C${mx},${sy} ${mx},${ty} ${tx},${ty}`;
  };
}
